export default {
    option: {
        value: 'profile',
        label: 'Profile',

        children: [
            {
                value: 'includes',
                label: 'Profile includes',

                select: {
                    content: 'profile'
                },

                match: (patient, args) => (Array.isArray(patient.profile) && args.some((arg) => patient.profile.includes(arg)))
            }
        ]
    }
}
